// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_3SUBGDVl","title":"_3i-S3aOu","intro":"_18fWJSiL"};